import { Check } from "lucide-react";
import { LAST_STEP, ONBOARDING_STEPS, TOTAL_STEPS } from "@/features/onboarding/steps";

const NUMBERED = ONBOARDING_STEPS.map((s, i) => ({ ...s, i })).filter((s) => s.n);

export function StepProgress({ current, onJump }) {
  const meta = ONBOARDING_STEPS[current];
  return (
    <nav data-testid="onboarding-progress" aria-label="Onboarding progress">
      <p className="mw-eyebrow sm:hidden">{meta.n ? `Step ${meta.n} of ${TOTAL_STEPS} · ${meta.label}` : `${meta.label} · before step ${TOTAL_STEPS}`}</p>
      <div className="mt-3 h-1 overflow-hidden rounded-full bg-muted sm:hidden">
        <div className="h-full bg-foreground transition-[width] duration-300" style={{ width: `${(current / LAST_STEP) * 100}%` }} />
      </div>
      <ol className="hidden grid-cols-8 gap-2 sm:grid">
        {NUMBERED.map((s) => {
          const state = s.i < current ? "done" : s.i === current ? "current" : "todo";
          return (
            <li key={s.key}>
              <button
                type="button"
                disabled={state === "todo"}
                onClick={() => onJump(s.i)}
                data-testid={`onboarding-progress-step-${s.key}`}
                data-state={state}
                className="group w-full text-left disabled:cursor-default"
              >
                <span className={`block h-[2px] w-full transition-colors ${state === "todo" ? "bg-border" : state === "current" ? "bg-gold" : "bg-foreground"}`} />
                <span className={`mt-3 flex items-start gap-1.5 font-mono leading-snug text-[10px] uppercase tracking-[0.08em] ${state === "todo" ? "text-muted-foreground/70" : "text-foreground"}`}>
                  {state === "done" ? <Check className="mt-0.5 h-3 w-3 shrink-0" /> : <span>0{s.n}</span>}
                  <span className="break-words group-enabled:group-hover:underline">{s.label}</span>
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
